export enum Position {
    left = 'left',
    right = 'right',
}

export enum VerticalPosition {
    up = 'up',
    down = 'down',
}

export enum Triggers {
    hover = 'hover',
    click = 'click',
}

export enum TagName {
    div = 'div',
    li = 'li',
}

export type OnOpenType = (() => void) | null;

export type OnCloseType = (() => void) | null;

export interface Props {
    isOpen?: boolean;
    dropdownClasses?: string;
    classes?: string;
    onOpen?: OnOpenType;
    onClose?: OnCloseType;
    position?: Position;
    verticalPosition?: VerticalPosition;
    triggerBy?: Triggers;
    noArrow?: boolean;
    disabled?: boolean;
    tagName?: TagName;
    delayMs?: number;
}
